// extracted by mini-css-extract-plugin
module.exports = {"right":"Header_right__2iLar","select":"Header_select__21tgK","clinic":"Header_clinic__2hb7E"};